import {
    HttpEvent,
    HttpRequest,
    HttpErrorResponse,
    HttpHandlerFn,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';

export function errorInterceptor(
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
    const keycloak = inject(Keycloak);
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {    
            if (
                error.status === 403 && error.error?.code === 'NETWORK_FORBIDDEN'
            ) {
                alert(
                    error.error.message ||
                    'Acceso denegado. Los usuarios con perfil de médico solamente pueden acceder a la aplicación desde la red sanitaria.'
                );
                keycloak.logout();
            }

            return throwError(() => error);
        })
    );
} 